import { createUseStyles } from 'react-jss';

var styles = {
  portfolioHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map